import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <FeaturesSection />
        <AppSection />
        <UpdatesSection />
        <CarouselSection />
        <MediaSection />
        <FaqSection />
        <RankingSection />
        <CardsSection />
        <AboutSection />
        <ContactSection />
        <IndexSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}